const BaggageHandColor = ({ color = '#bcbcbc' }) => {
  return (
    <svg
      width="24"
      height="37"
      viewBox="0 0 24 37"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.509329 34.6221C0.502711 34.9263 0.557619 35.2287 0.67076 35.5112C0.7839 35.7937 0.952941 36.0505 1.16774 36.266C1.38254 36.4816 1.63867 36.6515 1.92076 36.7657C2.20286 36.8798 2.5051 36.9358 2.80936 36.9302H21.2421C21.547 36.9369 21.8501 36.8817 22.1332 36.7681C22.4162 36.6544 22.6733 36.4847 22.889 36.269C23.1047 36.0533 23.2745 35.7962 23.3881 35.5132C23.5017 35.2301 23.5569 34.927 23.5502 34.6221V20.8056C23.5569 20.5011 23.5017 20.1983 23.388 19.9157C23.2743 19.6331 23.1044 19.3765 22.8886 19.1615C22.6728 18.9464 22.4156 18.7774 22.1326 18.6647C21.8496 18.552 21.5466 18.4978 21.2421 18.5056H2.80936C2.50549 18.499 2.20342 18.5539 1.92136 18.6671C1.6393 18.7804 1.38309 18.9495 1.16817 19.1645C0.953251 19.3794 0.784078 19.6356 0.670847 19.9176C0.557616 20.1997 0.502673 20.5018 0.509329 20.8056V34.6221Z"
        fill={color}
      />
      <path
        d="M12.7491 26.0643C12.7491 25.6648 12.4271 25.3409 12.0298 25.3409C11.6326 25.3409 11.3105 25.6648 11.3105 26.0643V31.5258C11.3105 31.9253 11.6326 32.2491 12.0298 32.2491C12.4271 32.2491 12.7491 31.9253 12.7491 31.5258V26.0643Z"
        fill="white"
      />
      <path
        d="M8.57135 4.31561H7.13281V18.4246H8.57135V4.31561Z"
        fill={color}
      />
      <path
        d="M16.9258 4.31561H15.4873V18.4246H16.9258V4.31561Z"
        fill={color}
      />
      <path
        d="M7.15723 4.60818H8.59576V3.74669C8.58701 3.44318 8.63953 3.14103 8.75018 2.85827C8.86082 2.57552 9.02732 2.31796 9.23974 2.101C9.45215 1.88403 9.70611 1.71211 9.98646 1.59549C10.2668 1.47888 10.5678 1.41997 10.8714 1.42228H13.1796C13.4841 1.41558 13.7869 1.47077 14.0695 1.5845C14.3521 1.69823 14.6087 1.86813 14.8237 2.08392C15.0388 2.29972 15.2078 2.55691 15.3205 2.83992C15.4332 3.12294 15.4874 3.42589 15.4796 3.73043V4.60818H16.91V3.74669C16.91 3.74669 16.91 0 13.1633 0H10.8714C10.8714 0 7.15723 -3.8754e-07 7.15723 3.74669V4.60818Z"
        fill={color}
      />
    </svg>
  );
};

export default BaggageHandColor;
